import { ApolloError, ServerError } from "@apollo/client";
import { PropsWithChildren, useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useCustomerNavSectionsV2 } from "routes/Customer/customerNavSectionsV2";
import { ScoutPopoverSessionProvider } from "routes/Customer/Scout/PopoverScout/ScoutPopoverSessionContext";

import { LayoutV2 } from "./LeftNavV2/LayoutV2";

function useHandleForbiddenTenant(error: ApolloError | undefined) {
  const navigate = useNavigate();

  useEffect(() => {
    // If the user is not authorized for this tenant, redirect to the home page.
    // This has the effect of auto switching to an authorized tenant.
    if (error && error.networkError && (error.networkError as ServerError).statusCode === 403) {
      navigate("/", { replace: true });
    }
  }, [error, navigate]);
}

export function Layout(props: PropsWithChildren) {
  const { error, navItems: customerNavSectionsV2 } = useCustomerNavSectionsV2();

  useHandleForbiddenTenant(error);

  return (
    <ScoutPopoverSessionProvider>
      <LayoutV2 navSections={customerNavSectionsV2}>
        {props.children}
        <Outlet />
      </LayoutV2>
    </ScoutPopoverSessionProvider>
  );
}
